<script setup lang="ts">
import { VDrawerTitle } from '~kui/vendor/vaul/drawer'
import { DialogTitle } from 'reka-ui'

import { useCredenzaContext } from './credenzaContext'

interface Props {
  asChild?: boolean;
}

withDefaults(defineProps<Props>(), {
  asChild: false,
})

const { isMobile } = useCredenzaContext()
const Comp = computed(() =>
  isMobile.value ? VDrawerTitle : DialogTitle,
)
</script>

<template>
  <component
    :is="Comp"
    :as-child="asChild"
    class="text-lg font-semibold leading-none tracking-tight"
  >
    <slot />
  </component>
</template>
